import HeaderLink from "./HeaderLink";
// import PlainLink from "./PlainLink";

export function StartFragment() {
  return (
    <>
      <HeaderLink to="/CustomerComplaint/index">Reklamacje</HeaderLink>
      {/* Product returns temporarily hidden. To restore, uncomment this link
          and the matching dashboard tile in StartPage/index.tsx. */}
      {/* <HeaderLink to="/ProductReturnRequest/index">Zwroty towarów</HeaderLink> */}
      <HeaderLink to="/ContractWithdrawal/new">
        Odstąpienie od umowy
      </HeaderLink>
      <HeaderLink to="/CableReel/index">Zwroty bębnów</HeaderLink>
      <HeaderLink to="/Consent/index">Zgody</HeaderLink>
      <HeaderLink to="/InnerAccount/myAccount">Moje konto</HeaderLink>
      <HeaderLink to="/About/contact">Kontakt</HeaderLink>
    </>
  );
}
